import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { AuthStateFacade } from '@zero/shared/util-global-state';
import { Asset, OrderData } from '@zero/shared/util-models';
import { environment } from 'environments/environment';
import { Observable } from 'rxjs';
import { CancelRequest, CancelResponse } from '../entities/cancel.entity';

@Injectable({ providedIn: 'root' })
export class EditOrderInfrastructure {
  constructor(
    private _http: HttpClient,
    private _authState: AuthStateFacade,
  ) {}

  public cancelOrder(orderId: string): Observable<CancelResponse> {
    const url = `${environment.apihost + environment.tradingServiceUrl}/order/cancel`;
    const { customerId: customer } = this._authState;
    return this._http.post<CancelResponse>(url, { customer, orderId } as CancelRequest);
  }

  public checkOrder(id: string): Observable<OrderData> {
    return this._http.get<OrderData>(`${environment.apihost}/api/trading/order/${id}`);
  }

  public getAsset(isin: string): Observable<Asset> {
    return this._http.get<Asset>(`${environment.apihost + environment.instrumentServiceUrl}/${isin}`);
  }
}
